<template>
  <div class="app-bookable-tariff-options-row row">
    <div class="tariff-option-outer-box col-sm-12 col-md-4"
         v-for="option in tariffOptions"
         :key="findIdentifier(option.tariffOptionId, option.tariffId, option.serviceId)">
      <a :class="'tariff-option-box ' + findIdentifier(option.tariffOptionId, option.tariffId, option.serviceId) +
          checkIfSelected(findIdentifier(option.tariffOptionId, option.tariffId, option.serviceId))"
         @click="select(findIdentifier(option.tariffOptionId, option.tariffId, option.serviceId), option.key)">
        <div :class="'field-'+field.name"
             v-for="field in fields"
             :key="field.pos"
             v-html="option[field.name]">
        </div>
      </a>
    </div>

  </div>
</template>
<script>
export default {
  methods: {
    findIdentifier (tariffOptionId, tariffId, serviceId) {
      if (tariffOptionId !== undefined) {
        return tariffOptionId
      }
      if (tariffId !== undefined) {
        return tariffId
      }
      if (serviceId !== undefined) {
        return serviceId
      }
      return 1
    },
    select (id, key) {
      this.$emit('select', { id: id, key: key })
    },
    checkIfSelected (id) {
      if (this.selected === id) {
        return ' selected'
      }
      return ''
    }
  },
  props: {
    tariffOptions: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    selected: {
      type: String,
      required: false
    }
  }
}
</script>
